<div class="survey-card" *ngIf="false && (customTranslations.surveyLinkUrl | o3rTranslate)">
  <div class="survey-card-content">
    <div class="text-section">
        <span class="refx-button text-section-title" [innerHTML]="customTranslations.surveyTitle | o3rTranslate"></span>
        <span class="text-section-content" [innerHTML]="customTranslations.surveyText | o3rTranslate"></span>
    </div>
    <div class="button-section">
        <a mat-flat-button
           class="survey-button"
           target="_blank"
           [attr.href]="customTranslations.surveyLinkUrl | o3rTranslate">
            <span [innerHTML]="customTranslations.surveyLinkLabel | o3rTranslate"></span>
        </a>
    </div>
  </div>
</div>
<div class="exit-link-container" *ngIf="isMmbButtonDisplayed$ | async">
  <a mat-flat-button
    tabindex="0"
    class="exit-link-button"
    [attr.href]="(deepLink$ | async)?.deeplink || (customTranslations.fallbackExitLinkUrl | o3rTranslate)"
    (keydown.enter)="onExitLinkClick($event)"
    (click)="onExitLinkClick($event)"
    trackClick
    [trackEventContextConstructor]="getAnalyticsEvent()">
  <span [innerHTML]="flavor==='refund' ? (customTranslations.exitLinkLabelRefund | o3rTranslate) : customTranslations.exitLinkLabel | o3rTranslate"></span>
  </a>
</div>